module.exports = "/_next/static/images/52bbc809522d62a4ccf498be6efd07bd-roxinho-details-metalico-lg@3x.jpg.webp";